import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const PinIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Pin",
    children: /*#__PURE__*/_jsx("path", {
      d: "m18.1 29.63-6.46-6.46L5 28.8c-.44.37-.97.64-1.56.77H3.3c-.04 0-.09.01-.14.01-.4 0-.73-.33-.73-.73v-.18c.14-.62.41-1.16.79-1.61s5.68-6.62 5.68-6.62l-6.48-6.5c-.24-.24-.4-.57-.4-.94 0-.57.36-1.05.86-1.23a8.623 8.623 0 0 1 5.88.61l-.05-.02 10.06-7.3-.5-.5c-.24-.24-.4-.58-.4-.95s.15-.71.4-.95l.27-.27c.24-.24.58-.4.95-.4s.71.15.95.4l9.11 9.11c.24.24.4.58.4.95s-.15.71-.4.95l-.27.27c-.24.24-.58.4-.95.4s-.71-.15-.95-.4l-.43-.41-7.3 10.08c.52 1.08.82 2.35.82 3.68 0 .75-.1 1.48-.28 2.18v-.06c-.18.5-.66.84-1.21.84-.36 0-.68-.14-.91-.37Z"
    })
  }));
};